import React from "react";
import "./Testimonial.css";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import TestimoniCard from "../../components/TestimoniCard/TestimoniCard";
import Slider from "react-slick";
import TestimonialData from "./TestimonialData";

const Testimonial = () => {


    // slider
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <section
            id="testimonial-section"
            className="section-bg common-padding"
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <SectionTitle
                            subTitle="TESTIMONIAL"
                            title="What people have said about us"
                            googleReviews={true}
                        />
                    </div>
             
                </div>

                <Slider {...settings} className="testimoni-slider">
                    {TestimonialData
                        .filter((testimonail) => testimonail.text?.trim()) // Exclude null or empty text
                        .map((testimonail) => (
                            <TestimoniCard
                                key={testimonail.id}
                                testimonail={testimonail}
                            />
                        ))}
                </Slider>
                <div className="swipe-indicator text-center mt-4">
                    <p style={{ color: "white" }}>
                        <span style={{ fontSize: "24px" }}>•••</span> Swipe to see more reviews
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Testimonial;
